<script >

import Aside from "@/components/Aside.vue";
import Header from "@/components/Header.vue";
export default {
  name:"Layout",
  components:{
    Header,
    Aside
  }
}
</script>

<template>
    <Header />
  <!--    主体-->
  <div style = "display:flex " >
    <Aside />
    <!--      内容区域-->
    <router-view style="flex: 1" />
  </div>
  <div style="text-align: center;background-color: #cccccc;width: 100%">
    <a href="https://beian.miit.gov.cn/" target="_blank">皖ICP备2024065058号-1</a>
  </div>
</template>

<style scoped>

</style>